import { render } from "./Home.vue?vue&type=template&id=ed6e5670&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=ed6e5670&scoped=true&lang=css"

import exportComponent from "C:\\untis\\dev\\others\\others-maria-gruber\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed6e5670"]])

export default __exports__